import React from "react";
export default function TrustIndexReviews() {
  return <section id="trustindexreviews" className="w-full bg-white py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex min-h-[120px] w-full flex-col items-center justify-center text-center">
          {}
          <div className="w-full">
            [trustindex no-registration=google]
          </div>
        </div>
      </div>
    </section>;
}